export function likeDesignAction(context, { designId, likeCount }) {
    context.dispatch('UPDATE_DESIGN_SUCCESS', {
        designId,
        likedByUser: true,
        likeCount: likeCount,
    });
}

export function unlikeDesignAction(context, { designId, likeCount }) {
    context.dispatch('UPDATE_DESIGN_SUCCESS', {
        designId,
        likedByUser: false,
        likeCount: likeCount,
    });
}

export function updateDesignAction(context, payload) {
    context.dispatch('UPDATE_DESIGN_SUCCESS', payload);
}



// WEBPACK FOOTER //
// ./src/js/apps/ddo/actions/index.js